import { useMemo, useState } from 'react'

import ImportWhitelist from './tabs/import-whitelist'
import VestingHistory from './tabs/vesting-history'
import VestingManagement from './tabs/vesting-management'
const enum TabVestingEnum {
  MANAGEMENT = 1,
  IMPORT_WHITELIST = 2,
  HISTORY = 3,
}

const TAB_CONTENT = [
  {
    label: 'Vesting Management',
    value: TabVestingEnum.MANAGEMENT,
    content: <VestingManagement />,
  },
  {
    label: 'Import Whitelist',
    value: TabVestingEnum.IMPORT_WHITELIST,
    content: <ImportWhitelist />,
  },
  {
    label: 'Vesting History',
    value: TabVestingEnum.HISTORY,
    content: <VestingHistory />,
  },
]

const Content = () => {
  const [tab, setTab] = useState(TabVestingEnum.MANAGEMENT)

  const content = useMemo(() => {
    return TAB_CONTENT.find((c) => c.value === tab)?.content || null
  }, [tab])

  return (
    <>
      <div className="tab-group">
        {TAB_CONTENT.map((tabContent, index) => {
          return (
            <p
              key={index}
              className={tab === tabContent.value ? 'selected' : ''}
              onClick={() => {
                setTab(tabContent.value)
              }}
            >
              {tabContent.label}
            </p>
          )
        })}
      </div>

      {content}
    </>
  )
}
export default Content
